import React, { useEffect, useState } from "react";
import { Card, Col, Row, Statistic, Typography, Space } from "antd";
import { 
  CheckCircleOutlined, 
  ClockCircleOutlined, 
  CloseCircleOutlined, 
  DollarCircleOutlined,
  DashboardOutlined
} from "@ant-design/icons";

import CertificatesLine from "./Dashboard/Charts/CertificatesLine";
import TopGaragesBarChart from "./Dashboard/Charts/TopGaragesBar";
import dashboardService from "../services/dashboard.service";

const { Title, Text } = Typography;

const BoardAdmin = () => {
  const [finished, setFinished] = useState(0);
  const [pending, setPending] = useState(0);
  const [cancelled, setCancelled] = useState(0);
  const [billing, setBilling] = useState(0);

  const fetchAll = async () => {
    try {
      const { finished } = await dashboardService.fetchFinished();
      const { pending } = await dashboardService.fetchPending();
      const { cancelled } = await dashboardService.fetchCancelled();
      const { total } = await dashboardService.fetchBilling();
      setFinished(finished);
      setPending(pending);
      setCancelled(cancelled);
      setBilling(total || 0);
    } catch (error) {
      console.error("Error fetching dashboard data", error);
    }
  };

  useEffect(() => {
    fetchAll();
  }, []);

  return (
    <div style={{ padding: '8px 0' }}>
      <Space direction="vertical" size="large" style={{ display: 'flex', width: '100%' }}>
        
        {/* Header Section */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            width: 48, height: 48, borderRadius: '12px', 
            background: 'linear-gradient(135deg, #1890ff 0%, #36cfc9 100%)',
            marginRight: '16px', color: '#fff', boxShadow: '0 4px 10px rgba(24,144,255,0.3)'
          }}>
            <DashboardOutlined style={{ fontSize: '24px' }} />
          </div>
          <div>
            <Title level={3} style={{ margin: 0, fontWeight: 700 }}>Dashboard General</Title>
            <Text type="secondary">Estadística y monitoreo del mes actual</Text>
          </div>
        </div>

        {/* Top KPIs Row */}
        <Row gutter={[24, 24]}>
          <Col xs={24} sm={12} md={6}>
            <Card bordered={false} style={{ borderRadius: '16px', backgroundColor: '#f6ffed', boxShadow: 'none' }}>
              <Statistic
                title={<span style={{ fontWeight: 600, color: '#5b8c00' }}>Finalizados</span>}
                value={finished}
                valueStyle={{ color: '#3f8600', fontWeight: 700, fontSize: '32px' }}
                prefix={<CheckCircleOutlined />}
              />
            </Card>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Card bordered={false} style={{ borderRadius: '16px', backgroundColor: '#fffbe6', boxShadow: 'none' }}>
              <Statistic
                title={<span style={{ fontWeight: 600, color: '#d48806' }}>Pendientes</span>}
                value={pending}
                valueStyle={{ color: '#faad14', fontWeight: 700, fontSize: '32px' }}
                prefix={<ClockCircleOutlined />}
              />
            </Card>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Card bordered={false} style={{ borderRadius: '16px', backgroundColor: '#fff1f0', boxShadow: 'none' }}>
              <Statistic
                title={<span style={{ fontWeight: 600, color: '#a8071a' }}>Anulados</span>}
                value={cancelled}
                valueStyle={{ color: '#cf1322', fontWeight: 700, fontSize: '32px' }}
                prefix={<CloseCircleOutlined />}
              />
            </Card>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Card bordered={false} style={{ borderRadius: '16px', backgroundColor: '#e6f7ff', boxShadow: 'none' }}>
              <Statistic
                title={<span style={{ fontWeight: 600, color: '#0050b3' }}>Facturación (S/)</span>}
                value={billing}
                precision={2}
                valueStyle={{ color: '#096dd9', fontWeight: 700, fontSize: '32px' }}
                prefix={<DollarCircleOutlined />}
              />
            </Card>
          </Col>
        </Row>

        {/* Charts Section */}
        <Row gutter={[24, 24]}>
          <Col xs={24} lg={12}>
            <Card 
              title={<span style={{ fontWeight: 600 }}>Evolución (12 Meses)</span>}
              bordered={false} 
              style={{ borderRadius: '16px', boxShadow: 'none', border: '1px solid #f0f0f0' }}
            >
              <CertificatesLine />
            </Card>
          </Col>
          <Col xs={24} lg={12}>
            <Card 
              title={<span style={{ fontWeight: 600 }}>Top 5 Talleres (Mes Actual)</span>}
              bordered={false} 
              style={{ borderRadius: '16px', boxShadow: 'none', border: '1px solid #f0f0f0' }}
            >
              <TopGaragesBarChart />
            </Card>
          </Col>
        </Row>
      </Space>
    </div>
  );
};

export default BoardAdmin;
